import { Breadcrumb, Button, Empty, Icon, Input, Table } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Panel } from 'src/components/Panel';
import { FormatDate } from 'src/components/table/Date';

interface State {}
interface Props {}
export interface Course {
  id: number;
  name: string;
  createdAt: Date;
  description: string;
}

const COURSE_LIST_QUERY = gql`
  query courseList {
    courses {
      id
      name
      description
      serialId
      createdAt
    }
  }
`;
export class CourseList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  searchByDataIndex = (selectedKeys?: React.Key[], confirm?: () => void) => {
    if (!selectedKeys || !confirm) {
      return;
    }
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters?: () => void) => {
    if (!clearFilters) {
      return;
    }
    clearFilters();
    this.setState({ searchText: '' });
  };

  private searchInput: Input | null;
  getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: (props: FilterDropdownProps) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={props.selectedKeys && props.selectedKeys[0]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            props.setSelectedKeys && props.setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.searchByDataIndex(props.selectedKeys && props.selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.searchByDataIndex(props.selectedKeys && props.selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜索
        </Button>
        <Button
          onClick={() => this.handleReset(props.clearFilters && props.clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          重置
        </Button>
      </div>
    ),
    filterIcon: (filtered: boolean) => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,

    onFilter: (value: string, record: any) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible: boolean) => {
      if (visible) {
        setTimeout(() => this.searchInput && this.searchInput.select());
      }
    },
  });

  render() {
    const columns = [
      {
        title: 'ID',
        key: 'id',
        dataIndex: 'id',
      },
      {
        title: 'SerialId',
        key: 'serialId',
        dataIndex: 'serialId',
      },
      {
        title: '课程名',
        key: 'name',
        dataIndex: 'name',
        ...this.getColumnSearchProps('name'),
      },
      {
        title: '描述',
        key: 'description',
        dataIndex: 'description',
      },
      {
        title: '生成日期',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: (createdAt: Date) => <FormatDate mode="datetime" date={createdAt} />,
      },
      {
        title: '操作',
        key: 'action',
        render: (row: { id: number }) => <Link to={`/course/${row.id}/lesson`}>查看</Link>,
      },
    ];
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>课程列表</Breadcrumb.Item>
        </Breadcrumb>
        <Panel style={{ marginTop: 10 }}>
          <Query query={COURSE_LIST_QUERY} variables={{}}>
            {({ loading, error, data }) => {
              if (error) return <div>{error.message}</div>;
              if (loading) return <div>loading...</div>;
              if (!data) {
                // @ts-ignore
                return <Empty />;
              }
              const courses = (data && data.courses) || [];

              return (
                <>
                  <Table columns={columns} pagination={false} dataSource={courses} rowKey={course => `${course.id}`} />
                </>
              );
            }}
          </Query>
        </Panel>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/course/CourseList.tsx